import r from "./_optimizeCb.js";
function t(t, a, o) {
  var e = Array(Math.max(0, t));
  a = r(a, o, 1);
  for (var i = 0; i < t; i++) e[i] = a(i);
  return e;
}
export { t as default };